import axios, { AxiosResponse } from 'axios';
import LoginCustomer from '../models/data/LoginCustomer';
import LoginRequest from '../models/requests/LoginRequest';
import { createRequestConfig } from './utils';

/**
 * ログイン要求またはログイン確認をする
 * @param url URL
 * @param req ログイン要求（ユーザー名、パスワード）
 * @returns ログインを待機するPromise（then: 200 <= status < 300、catch: その他）
 */
export function requestLogin(
  url: string,
  req?: LoginRequest,
): Promise<AxiosResponse<LoginCustomer>> {
  const config = createRequestConfig();
  if (req != null) {
    // ログイン要求
    return axios.post<LoginCustomer>(url, req, config);
  }
  // ログイン確認
  return axios.get<LoginCustomer>(url, config);
}

/**
 * ログアウト要求をする
 * @param url URL
 * @returns ログアウトを待機するPromise（then: 200 <= status < 300、catch: その他）
 */
export function requestLogout(url: string): Promise<AxiosResponse<void>> {
  const config = createRequestConfig();
  return axios.post<void>(url, {}, config);
}
